const config = {
    // BASE_URL: 'http://goldenkey/api'
    BASE_URL: 'https://api.goldenkey.marrar.co.mz/api'
}

export default config;